import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import styled from 'styled-components';

import HexagonIcon from '@mui/icons-material/Hexagon';

const HexagonBack = styled.div<{ clickable: boolean, size: string }>`
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    margin: 0 auto;
    position: relative;
    ${(props) => props.clickable ? "cursor: pointer;" : undefined}
`

const HexagonContent = styled.div`
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff
`;

export interface HexagonProps {
    name: string;
    content?: ReactNode;
    onClick?: () => void;
}

const Hexagon = (props: HexagonProps) => {
    return <>
        <HexagonBack clickable={props.onClick !== undefined} onClick={props.onClick} size='55px'>
            {/* <HexagonSide>
                {value.toolbox && <ToolsIcon fill={theme.palette.primary.main} />}
                {value.workshop && <WorkshopIcon fill={theme.palette.primary.main} />}
            </HexagonSide> */}
            <HexagonContent>
                <Box fontSize="55px"><HexagonIcon fontSize="inherit" color="primary" /></Box>
            </HexagonContent>
            {props.content !== undefined && <HexagonContent>
                {props.content}
            </HexagonContent>}
        </HexagonBack>
        <Typography variant="body1" textAlign={"center"}>{props.name}</Typography>
    </>
}

export default Hexagon;